export const APP_DATA_REVIEW_RESPONSE = 'APP_DATA_REVIEW_RESPONSE';

export const setAppReviewData = (data) => ({
  type: APP_DATA_REVIEW_RESPONSE,
  data: data,
});
